import { LocationHour } from './location-hour.model';
import { LocationEditModel } from './location-edit.model';

export class Location
{
    Id!: number;
    Name!: string;
    StreetAddress: string | undefined = undefined;
    City: string | undefined = undefined;
    State: string | undefined = undefined;
    Country: string | undefined = undefined;
    ZipCode: string | undefined = undefined;
    Longitude: number | undefined = undefined;
    Latitude: number | undefined = undefined;
    LocationText: string | undefined = undefined;
    PhoneNumber: string | undefined = undefined;
    IsMainLocation: boolean = false;
    HideInApp: boolean = false;
    LocationHours: LocationHour[] = [];

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json.LocationHours) this.LocationHours = json.LocationHours.map((jsonHour: any) => new LocationHour(jsonHour));
        }
    }

    updateFromModel(model: LocationEditModel)
    {
        Object.assign(this, model);
    }
}
